import { Inclusion } from '../realty/Realty';
import * as realty from '../realty/Realty';
import { Error } from '../realty/model/Error';
import DataStore from '../stores/DataStore';
import ErrorHandler from './ErrorHandler';
import { Report } from '../model/Report';
import { EventEmitter } from 'eventemitter3';
import { FetchingModel } from '../Events';
import { Response } from '../realty/model/Response';
import { Token } from '../realty/model/Token';
import { defined } from './Control';

const DATUM_WGS84 = 'WGS84';

export class Fetcher extends EventEmitter {
  private key: string;

  public fetchModelData(key: string): void {
    this.key = key;
    this.emit(FetchingModel);
    realty.fetch(
      'cadastres/' + key + '/validation/',
      validateCadastreInclusions(key),
      DataStore.getAuthenticationData().access_token,
      (response: Response) => {
        if (!defined(response.error)) {
          DataStore.storeAmbitaHousingValueReport(new Report(response));
        } else {
          ErrorHandler.handle(response.error);
        }
      }
    );
  }

  public fetchAuthenticationData(client: string, username: string, password: string): void {
    realty.authenticate(client, username, password, onAuthentication, onAuthenticationError);
  }

  public fetchedCadastreKey(): string {
    return this.key;
  }
}
export default new Fetcher();

function validateCadastreInclusions(key: string): Inclusion[] {
  return [new Inclusion('cadastre', cadastreRequestInclusions(key))];
}

function cadastreRequestInclusions(key: string): Inclusion[] {
  return [
    new Inclusion('buildings', [
      new Inclusion('units', [new Inclusion('address', [])], { cadastreKey: key }),
      new Inclusion('culturalheritages', []),
      new Inclusion('buildingchanges', [])
    ]),
    new Inclusion('presentationAddress', [new Inclusion('districts', [])]),
    new Inclusion('housingValue', []),
    new Inclusion('liensCalculation', [], { ignoreInterpretationFaults: true, onlyMaxCadastreLevel: true }),
    new Inclusion('affairs', []),
    new Inclusion('soilContaminations', []),
    new Inclusion(
      'ownershipsOwningThisCadastre',
      [new Inclusion('owningPerson', []), new Inclusion('conveyance', [])],
      { onlyMaxCadastreLevel: true }
    ),
    new Inclusion('surroundingHousingValues', [
      new Inclusion('presentationAddress', [], { datum: DATUM_WGS84 }),
      new Inclusion('cadastre', [], { datum: DATUM_WGS84 }),
      new Inclusion('buildings', [])
    ]),
    new Inclusion('singleHeritages', [])
  ];
}

function onAuthentication(authenticationData: Token): void {
  DataStore.setAuthenticationData(authenticationData);
}

function onAuthenticationError(error: Error): void {
  ErrorHandler.handle(error);
}



/** WEBPACK FOOTER **
 ** ./src/utility/Fetcher.ts
 **/